export const FETCH_LICENSE_SUMMARY_SUCCESS = "FETCH_LICENSE_SUMMARY_SUCCESS";
export const SET_LICENSE_SUMMARY_LOADING = "SET_LICENSE_SUMMARY_LOADING";
export const SET_SELECTED_COMPANY_ID = "SET_SELECTED_COMPANY_ID";
